import * as tslib_1 from "tslib";
import selectFolder from './selectFolder';
import { lazyAddFavoriteFolder, lazyRemoveFavoriteFolder } from 'owa-mail-favorites-store';
import { isFolderInFavorites } from 'owa-favorites';
import { getFolderIdForSelectedNode } from 'owa-mail-folder-forest-store';
import { getPersonaNodeIdFromExtendedProperty } from 'owa-mail-persona-search-folder-services';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { action } from 'satcheljs/lib/legacy';
/**
 * Toggle favorite state of a node
 * @param folder the folder
 */
export default action('toggleFavoriteFolder')(function toggleFavoriteFolder(folder, actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var favoriteNodeId, folderId, removeFavoriteFolder, addFavoriteFolder;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    favoriteNodeId = getPersonaNodeIdFromExtendedProperty(folder);
                    folderId = favoriteNodeId || folder.FolderId.Id;
                    if (!isFolderInFavorites(folderId)) return [3 /*break*/, 2];
                    // Reset the folder selection to inbox if unfavorite a selected node
                    if (folderId == getFolderIdForSelectedNode()) {
                        selectFolder(folderNameToId('inbox'), 'primaryFolderTree' /* treeType */);
                    }
                    return [4 /*yield*/, lazyRemoveFavoriteFolder.import()];
                case 1:
                    removeFavoriteFolder = _a.sent();
                    removeFavoriteFolder(folderId, actionSource);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, lazyAddFavoriteFolder.import()];
                case 3:
                    addFavoriteFolder = _a.sent();
                    addFavoriteFolder(folderId, actionSource);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=toggleFavoriteFolder.js.map